<template>
  <main class="sidebar-menu">
    <nav>
      <hybrid-link v-for="(route, i) in menuItems" :key="i"
                   class="menu-item"
                   :to="route.to"
                   @click="toggleMenu">
        <p-badge v-if="route.openCount" :content="route.openCount"
                 :variant="(route.badgeVariant) ? route.badgeVariant : 'danger'" />
        <p-icon :icon-name="route.icon" size="large"
                color="white" class="menu-icon"/>
        {{ route.name }}
      </hybrid-link>
    </nav>
  </main>
</template>

<script setup lang="ts">
import { useMenuStore, useDashboardStore, useBannersStore } from '@pidz/stores';
import { computed, ref } from 'vue';
import HybridLink from '../HybridLink.vue';

const dashboard = useDashboardStore();
const bannersStore = useBannersStore();
const menuStore = useMenuStore();

const screenWidth = ref(window.innerWidth);

const toggleMenu = () => {
  if (screenWidth.value >= 1200) {
    return;
  }

  menuStore.toggleMenu();
};

window.addEventListener('resize', () => {
  screenWidth.value = window.innerWidth;
});

const old_ffe: string = import.meta.env.VITE_FFE_OLD_URL;

const showCVBadge = computed(() => bannersStore.getBannerPerRoute('resume')?.length);

const menuItems = ref<MenuItem[]>([
    {
      name: 'Dashboard',
      icon: 'dashboard',
      to: `${old_ffe}/dashboard`,
    },
    {
      name: 'Agenda',
      icon: 'agenda',
      to: {
        name: 'calendar-month',
      },
    },
    {
      name: 'Opdrachten',
      icon: 'jobs',
      to: `${old_ffe}/shifts`,
    },
    {
      name: 'Overeenkomsten',
      icon: 'contract',
      to: `${old_ffe}/contracts`,
    },
    {
      name: 'Urenregistraties',
      icon: 'stopwatch',
      to: `${old_ffe}/sheets`,
    },
    {
      name: 'Facturen',
      icon: 'invoice',
      to: `${old_ffe}/invoices`,
      openCount: dashboard.openInvoiceCount,
    },
    {
      name: 'CV',
      icon: 'cv',
      to: { name: 'cv' },
      openCount: showCVBadge.value ? '!' : '',
      badgeVariant: 'warn'
    },
    {
      name: 'Reviews',
      icon: 'review',
      to: `${old_ffe}/reviews`,
    },
    {
      name: 'Support',
      icon: 'faq',
      to: `${old_ffe}/support/`,
    }
  ]
);
</script>
<style lang="scss">
.sidebar-menu {
  flex-grow: 1;
  margin-top: 16px;

  .menu-icon {
    margin-right: 16px;
  }

  .menu-item {
    position: relative;

    .badge {
      position: absolute;
      top: 0;
      left: 45px;
    }

    &.active {
      .badge {
        left: 41px;
      }
    }
  }
}
</style>
